import type {NotificationMetaData} from '../../types';

import {routes} from 'routes/routes';

export function resolveNotificationDeepLink(metaData: NotificationMetaData): string | undefined {
  if (!metaData.topic) {
    return undefined;
  }

  switch (metaData.topic) {
    case 'promotion_center':
      if (metaData.action === 'discount_set' || metaData.action === 'dsc_ending') {
        return `/services/promotion-center/campaign/${metaData.cycle_id}`;
      }
      return undefined;
    case 'pin':
      return routes.PROMOTION_CENTER_PIN_BUY_PACKAGE;
    case 'campaign':
      return metaData.external_url;
    case 'ticket':
      if (metaData.action === 'status_update' || metaData.action === 'new_comment') {
        return `/ticket/${metaData.ticket_id}`;
      }
      if (metaData.action === 'new_ticket') {
        return `/new_ticket?order_id=${metaData.order_id}`;
      }
      return undefined;
    case 'vps':
      return metaData.action === 'new_vps' ? '/vendor-score' : undefined;
    default:
      return '/';
  }
}
